export const kelvinImg = require("./Kelvin.jpg");
export const wwuImg = require("./Western Washington University Logo.png");
export const hi10Img = require("./hi10.jpg");
export const sinihhaImg = require("./sinihha.jpg");

export const githubImg = require("./GitHub_logo.png");
export const linkedinImg = require("./LinkedIn_logo.png");

export const notClassFinderImg = require("./NotClassFinder.jpg");

export const task1 = require("./1st Task.png");
export const task2 = require("./2nd Task.png");
export const task3 = require("./3rd Task.png");
export const task4 = require("./4th Task.png");


